import Vue from 'vue';
import store from './store';
import sCache from '@/plugins/simple-cache';
import Router from 'vue-router';

Vue.use(sCache, { store });
Vue.use(Router);

/**
 * Setting the current logged in user.
 */
store.commit('auth/loadSession');

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'home',
      component: () => import('@/pages/dashboard/SelectProperty'),
      meta: {
        requiresAuth: true,
        roles: [ 'LhhpUser' ],
        layout: 'default',
      },
    },

    // Auth
    {
      path: '/login',
      name: 'login',
      component: () => import('@/pages/auth/Login.vue'),
      meta: {
        layout: 'full-height',
      },
    },
    {
      path: '/reset-password',
      // name: 'reset-password',
      component: () => import('@/pages/auth/reset-password/ResetPassword.vue'),
      meta: {
        layout: 'full-height',
      },
      children: [
        {
          path: 'form',
          name: 'reset-password-form',
          component: () => import('@/pages/auth/reset-password/Form.vue'),
          meta: {
            layout: 'full-height',
          },
        },
        {
          path: 'success',
          name: 'reset-password-success',
          component: () => import('@/pages/auth/reset-password/Success.vue'),
          meta: {
            layout: 'full-height',
          },
        },
        {
          path: 'error',
          name: 'reset-password-error',
          component: () => import('@/pages/auth/reset-password/Error.vue'),
          meta: {
            layout: 'full-height',
          },
        },
        {
          path: '',
          name: 'reset-password-init',
          component: () => import('@/pages/auth/reset-password/Init.vue'),
          meta: {
            layout: 'full-height',
          },
        },
      ],
    },
    {
      path: '/register',
      component: () => import('@/pages/auth/register/Register'),
      meta: {
        layout: 'full-height',
      },
      children: [
        {
          path: 'success',
          name: 'register-success',
          component: () => import('@/pages/auth/register/Success.vue'),
          meta: {
            layout: 'full-height',
          },
        },
        {
          path: 'error',
          name: 'register-error',
          component: () => import('@/pages/auth/register/Error.vue'),
          meta: {
            layout: 'full-height',
          },
        },
        {
          path: 'activate',
          name: 'register-activate',
          component: () => import('@/pages/auth/register/Activate.vue'),
          meta: {
            layout: 'full-height',
          },
        },
        {
          path: "",
          name: 'register-form',
          default: true,
          component: () => import('@/pages/auth/register/Form'),
          meta: {
            layout: 'full-height',
          },
        },
      ],
    },
    {
      path: '/profile',
      name: 'profile',
      component: () => import('@/pages/dashboard/Profile.vue'),
      meta: {
        requiresAuth: true,
        roles: [ 'LhhpUser' ],
      },
    },
    {
      path: '/submissions/:uuid',
      component: () => import('@/pages/dashboard/Submission'),
      meta: {
        requiresAuth: true,
      },
      children: [
        {
          path: 'inspections',
          name: 'submissions-details',
          component: () => import('@/pages/dashboard/SubmissionDetails'),
          meta: {
            requiresAuth: true,
            roles: [ 'LhhpUser', 'LhhpAdmin' ],
            userBackBtn: {
              name: 'home',
              title: 'Return to my disclosures',
            },
            adminBackBtn: {
              name: 'home',
              title: 'Home',
            },
          },

          children: [
            {
              path: 'add',
              name: 'submit-inspections',
              component: () => import('@/pages/forms/InspectionsForm'),
              meta: {
                requiresAuth: true,
                roles: [ 'LhhpUser', 'LhhpAdmin' ],
                userBackBtn: {
                  name: 'home',
                  title: 'Return to my disclosures',
                },
                adminBackBtn: {
                  name: 'home',
                  title: 'Home',
                },
              },
            },
            {
              path: 'certify/:unit',
              name: 'submit-inspections-one',
              component: () => import('@/pages/forms/InspectionsForm'),
              meta: {
                requiresAuth: true,
                roles: [ 'LhhpUser', 'LhhpAdmin' ],
                userBackBtn: {
                  name: 'home',
                  title: 'Return to my disclosures',
                },
                adminBackBtn: {
                  name: 'home',
                  title: 'Home',
                },
              },
            },
            {
              path: 'update/:unit',
              name: 'update-inspections-one',
              component: () => import('@/pages/forms/InspectionsForm'),
              meta: {
                requiresAuth: true,
                roles: [ 'LhhpAdmin' ],
                userBackBtn: {
                  name: 'home',
                  title: 'Return to my disclosures',
                },
                adminBackBtn: {
                  name: 'home',
                  title: 'Home',
                },
              },
            },
            {
              path: 'view/:inspection',
              name: 'view-inspections-one',
              component: () => import('@/components/InspectionModal'),
              meta: {
                requiresAuth: true,
                roles: [ 'LhhpUser', 'LhhpAdmin' ],
                userBackBtn: {
                  name: 'home',
                  title: 'Return to my disclosures',
                },
                adminBackBtn: {
                  name: 'home',
                  title: 'Home',
                },
              },
            },
          ],
        },
        {
          path: 'inspections/add/success',
          name: 'submit-inspections-success',
          component: () => import('@/pages/dashboard/CertificationSuccess'),
          meta: {
            requiresAuth: true,
            roles: [ 'LhhpUser', 'LhhpAdmin' ],
            userBackBtn: {
              name: 'submissions-details',
              title: 'Return to disclosure dashboard',
            },
          },
        },
        {
          path: 'inspections/all',
          name: 'details-inspections',
          component: () => import('@/pages/dashboard/ListInspections'),
          meta: {
            requiresAuth: true,
            roles: [ 'LhhpUser', 'LhhpAdmin' ],
            userBackBtn: {
              name: 'submissions-details',
              title: 'Return to disclosure dashboard',
            },
          },
        },
        {
          path: '',
          name: 'submissions-new',
          component: () => import('@/pages/forms/EligibilityCheckForm'),
          meta: {
            requiresAuth: true,
            roles: [ 'LhhpUser', 'LhhpAdmin' ],
            userBackBtn: {
              name: 'home',
              title: 'Return to my disclosures',
            },
            adminBackBtn: {
              name: 'admin-find-drafts',
              title: 'Draft Certification',
            },
          },
        },
      ],
    },

    // Administrative routing
    {
      path: '/ad-auth',
      name: 'ad-auth',
      component: () => import('@/pages/auth/ad/Login'),
      meta: {
        layout: 'full-height',
        requiresAuth: false,
        roles: [],
      },
    },

    {
      path: '/admin',
      name: 'admin-home',
      component: () => import('@/pages/admin/dashboard/FindSubmissions'),
      meta: {
        roles: [ 'LhhpAdmin' ],
        requiresAuth: true,
      },
    },

    {
      path: '/admin/submissions/drafts',
      name: 'admin-find-drafts',
      component: () => import('@/pages/admin/dashboard/FindSubmissions'),
      meta: {
        roles: [ 'LhhpAdmin' ],
        requiresAuth: true,
      },
    },

    {
      path: '/admin/users',
      name: 'admin-users',
      component: () => import('@/pages/admin/users/Users'),
      meta: {
        requiresAuth: true,
        roles: [ 'LhhpAdmin' ],
      },
    },

    {
      path: '/cases',
      name: 'cases',
      component: () => import('@/pages/case/Cases'),
      meta: {
        requiresAuth: true,
        roles: [ 'LhhpAdmin', 'LhhpUser' ],
        userBackBtn: {
          name: 'home',
          title: 'Return to my disclosures',
        },
      },
      children: [
        {
          path: ':uuid/case',
          name: 'single-case',
          component: () => import('@/pages/case/Case'),
          meta: {
            requiresAuth: true,
            roles: [ 'LhhpAdmin', 'LhhpUser' ],
          },
        },
        // {
        //   path: '/',
        //   name: 'cases',
        //   default: true,
        //   component: () => import('@/pages/case/Cases'),
        //   meta: {
        //     layout: 'full-height',
        //   },
        // },
      ],
    },

    // Others
    {
      path: '/faq',
      name: 'faq',
      component: () => import('@/pages/faq'),
    },

    {
      path: '/contact-us',
      name: 'contact-us',
      component: () => import('@/pages/ContactUs'),
    },

    {
      path: '/hangfire',
      name: 'hangfire-redirect',
      component: () => import('@/pages/admin/GoToHangfire'),
      meta: {
        requiresAuth: true,
        roles: [ 'LhhpAdmin' ],
      },
    },

    {
      path: '/maintenance',
      name: 'maintenance',
      component: () => import('@/pages/maintenance'),
      meta: {
        requiresAuth: false,
        layout: 'full-height',
      },
    },

    // Payment response statuses
    {
      path: '/payment/:status',
      name: 'payment',
      component: () => import('@/pages/PaymentResponse'),
      meta: {},
    },
    {
      path: '/cases/:uuid/case/payment/:status',
      name: 'single-case-payment',
      component: () => import('@/pages/PaymentResponse'),
      meta: {},
    },
  ],
});

router.beforeEach(async (to, from, next) => {
  // Guard for succes submission page, this page is only loaded if submittedDate exists

  if (to.name === 'submit-inspections-success') {
    console.log("asdfasdf");
    if (!store.state.properties.successDate) {
      next({ name: 'submissions-details', params: to.params });
      return;
    }
  }
  
  if (to.matched.some(record => record.meta.requiresAuth)) {
    const isAuthenticated = store.state.auth.isAuthenticated;
    if (!isAuthenticated) {
      next({ name: 'login' });
    } else {
      await store.dispatch('cases/getOpenAttentionCases');
      if (to.meta.roles.some(role => store.state.auth.account.roles.indexOf(role) >= 0)) {
        next();
      } else {
        if (store.state.auth.account.roles[0] === 'LhhpUser') {
          next({ name: 'home' });
        } else if (store.state.auth.account.roles[0] === 'LhhpAdmin') {
          next({ name: 'admin-home' });
        } else {
          // Epidemiologist does not have a login so far... So... logout
          store.dispatch('phillyAccount/msalSignOut');
        }
      }
    }
  } else {
    next();
  }
});

router.afterEach(async (to, from) => { // eslint-disable-line
});

export default router;
